import React, { useEffect, useState } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import TextField from '../../Components/customComponents/customTextField'
import { genericHeaders, serviceUrl } from '../../utils/apiConfig'
import axios from 'axios'
import { updateEmployeeJson, updateInviteEmployeeMetaData } from '../../store/reducers/addEmployeeSlice'
import { useDispatch } from 'react-redux'
import { getToken, setToken } from '../../services/Token'
import addEmployeeJson from "../addEmployee/addEmployee.json";


const LoginEmlpoyeeInvite = () => {
  const [email, setemail] = useState("")
  const [userId, setUserId] = useState("")
  const [decoded , setDecoded] = useState([])
  const [errorMessage , setErrorMessage] = useState("")
  let inviteEmployee = JSON.parse(JSON.stringify(addEmployeeJson)); 
  let [linkExpire, setLinkExpire] = useState("")
  

  let dispatch = useDispatch()
  const emailPattern = /^[a-zA-Z0-9][^\s@]*@[^\s@]+\.[a-zA-Z]+$/;
 
  let navigate = useNavigate()
    let {encripted} = useParams()

    let submitForm = async ()=>{
       if(email.trim()===decoded[0] && userId===decoded[1]){
          setToken("inviteEmployeeEncripted", encripted)
          await navigateUser()
       }else{
        setLinkExpire(false)         
        setErrorMessage("Pelese enter Correct email and UserId")
       }
    }

    useEffect(()=>{
      try{
         let decoded = atob(encripted);
         let split = decoded.split("::")
         setDecoded(split)
        }catch(error){
      console.error(error);     
    }
    },[])

    const handleChange = (e)=>{
      const {name, value} = e.target
      if(name==="email"){
        setemail(prev=> value)        
      }
      if(name==="userId"){
        setUserId(prev=>value)
      }
    }

    const navigateUser = async ()=>{
      try {
        let url = `${serviceUrl}/api/sendinvitation/onboarding/details?encodedString=${encripted}`
        let response = await axios.get(url)
        if(response.status===200){   
          const data = response.data.data.employeeinfo;
          const metaData = response.data.data.metadata;
          const { professionalDetails, personalDetails } = data;  
          const updatedInviteEmployee = {
            ...inviteEmployee,
            get_id: data._id,
            firstName: data.firstName,
            lastName: data.lastName,
            isManager: data.isManager,
            professionalDetails: {
              ...inviteEmployee.professionalDetails,
              employeeId: professionalDetails.employeeId,
              status: professionalDetails.status,
              dateofJoining: professionalDetails.dateofJoining,
              noticePeriod: professionalDetails.noticePeriod,
              shift: professionalDetails.shift,
              probationPeriod: professionalDetails.probationPeriod,
              confirmationDate: professionalDetails.confirmationDate,
              totalExperience: professionalDetails.totalExperience,
              currentCompanyExperience: professionalDetails.currentCompanyExperience,
              referedBy: professionalDetails.referedBy,
              department: professionalDetails.department,
              currentDesignation: professionalDetails.currentDesignation,
              holidayCalender: professionalDetails.holidayCalender,
              employeeType: professionalDetails.employeeType,
              managerId: professionalDetails.managerId,
              workLocation: professionalDetails.workLocation,
              companyEmail: professionalDetails.companyEmail,
            },
            personalDetails: {
              ...inviteEmployee.personalDetails,
              email: personalDetails.email,
              dob: personalDetails.dob,
            }
          };
          setLinkExpire(false)
          dispatch(updateEmployeeJson(updatedInviteEmployee))
          dispatch(updateInviteEmployeeMetaData(metaData))
          navigate("/employeeinvite")
        }
      } catch (error) {
        console.error(error);
        if(error.response.status ===410){
          setLinkExpire(true)        
          setErrorMessage('')
        }else{
          setLinkExpire(false)         
          setErrorMessage(error?.response?.data?.message)
        }
      }
    }
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className=" gap-5 shadow-xl w-[40%] h-auto p-10 flex flex-col items-center justify-center rounded-lg">
        <h2 className="text-2xl font-serif text-purple-800 mt-3 ml-3 cursor-default my-5">
          <span className="font-extrabold">work</span>
          <span className="font-extrabold">force</span>
          <span className="text-3xl font-extrabold text-blue-600">HR</span>
        </h2>
        <div className="flex flex-col items-end">
          <TextField
            label={"E-mail"}
            type={"email"}
            name={"email"}
            value={email}
            placeHolder={"Enter the Email"}
            onChange={(e) => handleChange(e)}
          />

          <TextField
            label={"Employee ID"}
            type={"text"}
            name={"userId"}
            value={userId.toUpperCase()}
            placeHolder={"Enter the ID"}
            onChange={(e) => handleChange(e)}
          />
        </div>

        {linkExpire && (
          <p className="text-red-600  font-medium">Link Expired</p>
        )}
        {errorMessage && (
          <p className="text-red-600  font-medium">{errorMessage}</p>
        )}
        <button
          className="ml-[30%] bg-blue-400 text-white p-2 rounded-md hover:bg-blue-500"
          onClick={() => submitForm()}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default LoginEmlpoyeeInvite
